var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticStyle: {
      "line-height": "20px",
      color: "#ff4d4f",
      padding: "10px"
    }
  }, [_vm._v(" *" + _vm._s(_vm.$t("该模块将读取产品发布-内容管理中理赔流程数据")) + " ")])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };